module.exports = "../../app/cells/components/modals/planner_modal_cell.rb";